import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import qs from "qs";
import router from "../router/router";
import FragmentsRenderer from '@/externals/FragmentRenderer';
import feather from 'feather-icons';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    view: {
      isLoading: true,
      isLoadingProducts: false,
      isLoadingAttributes: false,
      type: ws_vue_store.config["product-grid"],
      categoryPath: '',
      sort: "default",
      perPage: 25,
      perPageOptions: [25, 250, 500],
      page: 1
    },
    filters: {
      first: null,
      current: {},
      onSaleProducts: false,
      newProducts: false,
      priceSlider: {
        min: null,
        max: null
      }
    },
    wishlist: {
      activeItems: [],
      viewItems: [],
      isOwner: false,
      viewCount: 0,
      viewTotal: 0
    },
    numberSeparator : ',',
    searchMode: false,
    productsHighestPrice: 0,
    productsCount: 0,
    discountCategory: 0,
    isRentCategory: false,
    searchProducts: [],
    recentlyAddedProducts: [],
    selectedPackages: {},
    products: [],
    attributeTaxonomies: [],
    filteredAttributeTaxonomies: [],
    allowedCategoryAttributes: [],
    showExcludedAttributes: true,
    attributesFirstLoadingState: true,
    onlySidebar: false,
    isUpsellArchive: false,
    categories: [],
    previouslyViewed: [],
    taxesEnabled: true,
    isSKUSearch: false,
  },
  getters: {
    getViewWishlistItem: state => productId => {
      let index = state.wishlist.viewItems.findIndex(e => e.product_id == productId);
      return index != -1 ? state.wishlist.viewItems[index] : null;
    },
    getViewWishlistTotal: state => {
      return state.wishlist.viewTotal;
    },
    getViewWishlistCount: state => {
      return state.wishlist.viewCount;
    },
    getIsViewWishlistOwner: state => {
      return state.wishlist.isOwner;
    },
    isInActiveWishlist: state => productId => {
      return state.wishlist.activeItems.findIndex(e => e.product_id == productId) !== -1;
    },
    getViewWishlistQuantity: state => productId => {
      let index = state.wishlist.viewItems.findIndex(e => e.product_id == productId);
      return index != -1 ? Number(state.wishlist.viewItems[index].quantity) : 0;
    },
    getViewWishlistPackage: state => productId => {
      let index = state.wishlist.viewItems.findIndex(e => e.product_id == productId);
      return index != -1 ? Number(state.wishlist.viewItems[index].quantity) : 0;
    },
    getActiveWishlistCount: state => {
      return state.wishlist.activeItems.length;
    },
    getNumberSeparator: state => {
      return state.numberSeparator;
    },
    getFiltersFromUrl: state => () => {
      var queryParams = qs.parse(window.location.search.substr(1));
      if ( ! queryParams.ws_sort)
        queryParams.ws_sort = ws_vue_store.catalog_orderby_options[0].code;
      if ( ! queryParams.ws_page)
        queryParams.ws_page = 1
      if ( ! queryParams.ws_per_page)
        queryParams.ws_per_page = 25;

      return queryParams;
    },
    getActiveFiltersCount: state => {
      let filters = Object.keys(state.filters.current);

      if (ws_vue_store.empty_filters_ignore_category) {
        let t = filters.indexOf('product_cat')
        if (t != -1)
          filters.splice(t, 1);
      }

      return filters.length;
    },
    getSearchMode: state => {
      return state.searchMode;
    },
    getTaxesEnabled: state => {
      return state.taxesEnabled;
    },
    getSKUSearchMode: state => () => {
      return state.isSKUSearch;
    },
    getType: state => {
      return state.view.type;
    },
    getAttributeTaxonomy: state => key => {
      if (state.attributeTaxonomies.length === 0) {
        return null;
      }
      const foundAttributeTaxonomy = state.attributeTaxonomies.find(
        attributeTaxonomy => attributeTaxonomy.key === key
      );
      if (foundAttributeTaxonomy === undefined) {
        return null;
      }
      return foundAttributeTaxonomy;
    },
    getProducts: state => {
      return state.products;
    },
    getDiscountCategory: state => {
      return state.discountCategory;
    },
    getIsRentCategory: state => {
      return state.isRentCategory;
    },
    getFilteredAttributeTaxonomies: (state, getters) => {
      const allowed_sidebar_filters = ws_vue_store.config['allowed_sidebar_filters'];

      if(ws_vue_store.disable_filters_relationship == 1){
        state.filteredAttributeTaxonomies.map(attribute => {
          attribute.options.map(option => {
            option.excluded_filter = false;
          })
        });
      }

      if(Object.keys(state.filters.current).length == 0){
        return state.filteredAttributeTaxonomies;
      }
      if(state.attributesFirstLoadingState){
        state.attributesFirstLoadingState = false;
        return state.filteredAttributeTaxonomies;
      }
      if(allowed_sidebar_filters == undefined) return [];
      let allAttributes = state.attributeTaxonomies.filter(attr => allowed_sidebar_filters.includes(attr.key));

      if(ws_vue_store.disable_filters_relationship == 1){
        return allAttributes;
      }
      
      state.filteredAttributeTaxonomies.map(attr => {
        let findAttributeIndex = allAttributes.findIndex(attribute => attribute.key == attr.key);
        if(findAttributeIndex != -1){
          allAttributes[findAttributeIndex].options.map(option => {
            if(attr.options.find(opt => opt.slug == option.slug)){
              option.excluded_filter = false;
            } else {
              option.excluded_filter = true;
            }
          })
        }
      });

      allAttributes.map(attribute => {
        let found = state.filteredAttributeTaxonomies.find(attr => attr.key == attribute.key);
        if(!found){
          attribute.options.map(option => {
            option.excluded_filter = true;
          });
        }
      });

      return allAttributes;
    },
    getSearchedProducts: (state, getters) => {
      return state.searchProducts;
    },
    getRecentlyAddedProducts: (state, getters) => {
      return state.recentlyAddedProducts;
    },
    getSelectedPackages: (state, getters) => {
      return state.selectedPackages;
    },
    getHighestPrice: (state, getters) => {
      return state.productsHighestPrice;
    },
    isDiscountedProductsPage(state, getters){
      return state.filters.onSaleProducts;
    },
    isNewProductsPage(state, getters){
      return state.filters.newProducts;
    },
    /**
     * Get search term for filter.
     * Convert special characters for database search
     */
    getSearchTerm: (state) => () => {
      if (state.filters.keyword) {
        return state.filters.keyword
          .replace('&', '&amp;');
      }
      return null;
    },
    isHomePage: (state) => () => {
      if (Object.keys(state.filters.current).length || state.filters.keyword || router.currentRoute.name !== "Archive" ) {
        return false;
      }

      return true;
    },
    getCategoryPath: (state) => categoryID => {
      let slugs = [];
      let currentCat = null;
      while (categoryID) {
        currentCat = state.categories.find(c => c.term_id === categoryID);
        if (currentCat) {
          slugs.push(currentCat.slug);
          categoryID = currentCat.parent;
        } else {
          categoryID = 0;
        }
      }

      if (slugs.length) {
        let path = slugs.reverse().join('/');
        return `${ws_vue_store.site_url}/${ws_vue_store.sub_urls.category_base}/${path}/`;
      }
      return `${ws_vue_store.site_url}${ws_vue_store.sub_urls.shop}/`;
    },
    getAllowedAttributes(state, getters){
      let allowedAttributes = ws_vue_store.config.allowed_attributes;
      if(state.allowedCategoryAttributes != undefined && state.allowedCategoryAttributes.length > 0){
        return state.allowedCategoryAttributes;
      }
      return allowedAttributes;
    }
  },
  mutations: {
    setIsViewWishlistOwner(state, value) {
      state.wishlist.isOwner = Boolean(value);
    },
    setActiveWishlistItems(state, items) {
      state.wishlist.activeItems = items;
    },
    setViewWishlistItems(state, items) {
      state.wishlist.viewItems = items;
    },
    setViewWishlistTotal(state, total) {
      state.wishlist.viewTotal = Number(total);
    },
    setViewWishlistCount(state, count) {
      state.wishlist.viewCount = Number(count);
    },
    updateViewWishlistCount(state, change) {
      state.wishlist.viewCount += change;
    },
    updateViewWishlistTotal(state, total) {
      state.wishlist.viewTotal += Number(total);
    },
    addToActiveWishlist(state, data) {
      let index = state.wishlist.activeItems.findIndex(e => e.product_id == data.product_id);
      if (index != -1) {
        state.wishlist.activeItems[index] = data;
      } else {
        state.wishlist.activeItems.push(data);
      }
    },
    removeFromActiveWishlist(state, productId) {
      const index = state.wishlist.activeItems.findIndex(e => e.product_id == productId);
      if (index > -1) {
        state.wishlist.activeItems.splice(index, 1);
      }
    },
    setTaxesEnabled(state, value) {
      state.taxesEnabled = value;
    },
    setSKUSearch(state, value) {
      state.isSKUSearch = value;
    },
    changeLoadingState(state, newState) {
      state.view.isLoading = newState;
    },
    changeProductsLoadingState(state, newState) {
      state.view.isLoadingProducts = newState;
    },
    changeAttributesLoadingState(state, newState) {
      state.view.isLoadingAttributes = newState;
    },
    changeViewType(state, newType) {
      state.view.type = newType;
    },
    changePerPage(state, value) {
      state.view.perPage = parseInt(value, 10);
      if (parseInt(router.currentRoute.query.ws_per_page) !== parseInt(value, 10) && state.isUpsellArchive === false) {
        router.push({ query: { ...router.currentRoute.query, ws_per_page: parseInt(value, 10) } });
      }
    },
    scrollToSavedPosition(state) {
      const savedYPosition = sessionStorage.getItem(window.location.href);
      if (savedYPosition) {
        window.scrollTo(0, savedYPosition);
      }
    },
    setFirstPage(state) {
      state.view.page = 1;
    },
    changeCurrentPage(state, newVal) {
      if (state.view.isLoading) {
        state.view.page = newVal;
        return;
      }

      if (state.productsCount === 0 || newVal < 1) {
        state.view.page = 1;
      } else if (state.productsCount >= (((newVal - 1) * state.view.perPage) + 1)) {
        state.view.page = newVal;
      } else {
        state.view.page = 1;
      }

      if (parseInt(router.currentRoute.query.ws_page, 10) !== parseInt(state.view.page, 10)) {
        router.push({
          query: {
            ...router.currentRoute.query,
            ws_page: parseInt(state.view.page, 10)
          }
        });
      }
    },
    changeShowExcludedAttributes(state, newVal){
      state.showExcludedAttributes = newVal;
    },
    changeAttributesFirstLoadingState(state, newVal){
      state.attributesFirstLoadingState = newVal;
    },
    setProductsHighestPrice(state, price) {
      state.productsHighestPrice = Math.ceil(price);
    },
    setOnlySidebar(state, value) {
      state.onlySidebar = value;
    },
    setIsUpsellArchive(state, value) {
      state.isUpsellArchive = value;
    },
    setProductsCount(state, count) {
      state.productsCount = count;
    },
    setSearchProducts(state, products) {
      state.searchProducts = products;
    },
    setRecentlyAddedProduct(state, product){
      state.recentlyAddedProducts.push(product);
    },
    setSelectedPackages: (state, data) => {
      return state.selectedPackages = data;
    },
    addSelectedPackages: (state, data) => {
      return state.selectedPackages[data.id] = data.package;
    },
    setProducts(state, products) {
      state.products = products;
    },
    setDiscountCategory(state, discountCategory) {
      state.discountCategory = discountCategory;
    },
    setIsRentCategory(state, data) {
      state.isRentCategory = data;
    },
    setFilteredAttributeTaxonomies(state, filteredAttributeTaxonomies){
      const allowed_sidebar_filters = ws_vue_store.config['allowed_sidebar_filters'];
      if(allowed_sidebar_filters == undefined) return [];
      state.filteredAttributeTaxonomies = filteredAttributeTaxonomies.filter(attr => allowed_sidebar_filters.includes(attr.key));
    },
    setAttributeTaxonomies(state, attributeTaxonomies) {
      state.attributeTaxonomies = attributeTaxonomies;
    },
    setCategories(state, categories) {
      state.categories = categories;
    },
    setNumberSeparator(state, separator) {
      state.numberSeparator = separator;
    },
    setCategoryFromPath(state, routeParams) {
      let currentCategorySlug = routeParams.split('/').at(-1);
      const matchingCategory = state.categories.find(
        category => category.slug === currentCategorySlug
      );
      if (matchingCategory) {
        state.filters.current = { ...state.filters.current, ["product_cat"]: [matchingCategory.term_id] };
      }
    },
    updatePriceFilter(state, payload){
      if(payload.type == 'min'){
        state.filters.priceSlider.min = payload.value;
      } else if(payload.type == 'max'){
        state.filters.priceSlider.max = payload.value;
      }
    },
    updateCategoryPath(state) {
      let breadcrumbEl = document.querySelector('#breadcrumbs');
      let breadcrumbIcon = feather.icons['chevron-right'].toSvg();
      if (state.filters.current && state.filters.current.product_cat) {
        let names = [];
        let slugs = [];
        let currentID = state.filters.current.product_cat[0];
        let currentCat = null;
        while (currentID) {
          currentCat = state.categories.find(c => c.term_id === currentID);
          if (currentCat) {
            slugs.push(currentCat.slug);
            names.push(currentCat.name);
            currentID = currentCat.parent;
          } else {
            currentID = 0;
          }
        }

        if (slugs.length) {
          let path = slugs.reverse().join('/');
          state.view.categoryPath = `/${ws_vue_store.sub_urls.category_base}/${path}/`;

          if (breadcrumbEl) {
            // Update breadcrumps
            names[0] = `<span class="breadcrumb_last" aria-current="page">${names[0]}</span>`;
            names.reverse();
            let slugs_temp = [];
            for (let index = names.length-2; 0 <= index; index--) {
              slugs_temp.push(slugs[index]);
              let currentPath = `${ws_vue_store.site_url}/${ws_vue_store.sub_urls.category_base}/${slugs_temp.join('/')}/`;
              names[index] = `<span><a href="${currentPath}">${names[index]}</a></span>`;
            }
            names = [`<span><a href="${ws_vue_store.site_url}/">Avaleht</a></span>`, ...names];
            breadcrumbEl.childNodes[0].innerHTML = names.join(`<span class="breadcrumbs__separator">${breadcrumbIcon}</span>`);
          }

          return;
        }
      }

      state.view.categoryPath = `${ws_vue_store.sub_urls.shop}/`;
      if (breadcrumbEl) {
        // Update breadcrumps
        let names = [
          `<span><a href="${ws_vue_store.site_url}/">Avaleht</a></span>`,
          '<span class="breadcrumb_last" aria-current="page">E-pood</span>',
        ];
        breadcrumbEl.childNodes[0].innerHTML = names.join(`<span class="breadcrumbs__separator">${breadcrumbIcon}</span>`);
      }
    },
    isCurrentCategoryRent(state) {
      let value = false;
      let rentCategoryID = Number(ws_vue_store.rent_category);
      if (rentCategoryID && state.filters.current && state.filters.current.product_cat) {
        let categoryID = state.filters.current.product_cat[0];
        while (categoryID) {
          if (categoryID === rentCategoryID) {
            value = true;
            break;
          }

          let currentCat = state.categories.find(c => c.term_id === categoryID);
          categoryID = currentCat ? currentCat.parent : 0;
        }
      }

      state.isRentCategory = value;
    },
    addFilter(state, payload) {
      if (payload.option === undefined || payload.taxonomy === undefined) {
        return;
      }

      if(payload.taxonomy == 'lang'){
        state.lang = payload.option;
        return;
      }

      if (state.filters.first === null) {
        state.filters.first = payload.taxonomy;
      }

      if(payload.taxonomy == 'keyword'){
        state.filters.keyword = payload.option;
        return;
      }

      if(payload.taxonomy == "product_cat"){
        if(isNaN(payload.option)) return;
      }

      if(payload.taxonomy == 'on_sale_products'){
        state.filters.onSaleProducts = payload.option;
        return;
      }

      if(payload.taxonomy == 'is_new'){
        state.filters.newProducts = payload.option;
        return;
      }

      if (
        state.filters.current[payload.taxonomy] === undefined ||
        payload.taxonomy === "product_cat"
      ) {
        state.filters.current = { ...state.filters.current, [payload.taxonomy]: [payload.option] };
        return;
      }
      state.filters.current = {
        ...state.filters.current,
        [payload.taxonomy]: [
          ...new Set([...state.filters.current[payload.taxonomy], payload.option])
        ]
      };
    },
    removeFilter(state, payload) {
      if (payload.taxonomy in state.filters) {
        delete state.filters[payload.taxonomy];

      } else if (payload.taxonomy in state.filters.current) {
        if (
          payload.taxonomy === "product_cat" &&
          state.filters.current[payload.taxonomy].length === 1
        ) {
          state.filters.current = {};
          state.filters.first = null;

        } else if (state.filters.current[payload.taxonomy].length === 1) {
          delete state.filters.current[payload.taxonomy];

          if (state.filters.first === payload.taxonomy) {
            let currentFilters = Object.keys(state.filters.current);
            let validFilterIndex = currentFilters.findIndex(
                filterKey => state.filters.current[filterKey].length
            );

            if (validFilterIndex == -1) {
              state.filters.first = null;
            } else {
              state.filters.first = currentFilters[validFilterIndex];
            }
          }

        } else {
          state.filters.current[payload.taxonomy] = state.filters.current[payload.taxonomy].filter(
            filter => filter !== payload.option
          );
        }

        if (payload.taxonomy === "product_cat") {
          state.view.categoryPath = `${ws_vue_store.sub_urls.shop}/`;
        }
      }
    },
    clearFilters(state, options) {
      if (options.ignoreCategory && state.filters.current.product_cat) {
        state.filters.current = {
          product_cat: state.filters.current.product_cat
        };
      } else {
        state.filters.current = {};
      }

      state.filters.first = null;
      state.filters.priceSlider.min = 0;
      state.filters.priceSlider.max = 0;
      state.view.page = 1;
      state.showExcludedAttributes = true;
    },
    updateUrlQuery(state) {
      const mapped = {};

      Object.keys(state.filters.current).forEach(key => {
        mapped[`ws_${key}`] = state.filters.current[key];
      });
      delete(mapped.ws_product_cat);

      if(typeof state.filters.keyword !== 'undefined' && state.filters.keyword){
        mapped['search_term'] = state.filters.keyword;
      }

      if(typeof state.lang !== 'undefined' && state.lang){
        mapped['lang'] = state.lang;
      }

      if(typeof state.filters.onSaleProducts !== 'undefined' && state.filters.onSaleProducts){
        mapped['on_sale_products'] = state.filters.onSaleProducts;
      }

      if(typeof state.filters.newProducts !== 'undefined' && state.filters.newProducts){
        mapped['is_new'] = state.filters.newProducts;
      }

      if (state.view.page > 1) {
        mapped['ws_page'] = state.view.page;
      }

      if (state.view.perPage != 25) {
        mapped['ws_per_page'] = state.view.perPage;
      }

      if (state.view.sort.code != ws_vue_store.catalog_orderby_options[0].code) {
        mapped['ws_sort'] = state.view.sort.code;
      }

      router.push({ path: state.view.categoryPath, query: mapped });
    },
    setSort(state, selected) {
      state.view.sort = selected;
      if (router.currentRoute.query.ws_sort !== selected.code && selected.code !== ws_vue_store.catalog_orderby_options[0].code) {
        router.push({ query: { ...router.currentRoute.query, ws_sort: selected.code } });
      }
    },
    addProductToViewedList(state, product) {
      if (!product) {
        return;
      }
      if (state.previouslyViewed.length >= parseInt(ws_vue_store.previous_views_quantity, 10)) {
        state.previouslyViewed.splice(0, 1);
      }
      let productFound = state.previouslyViewed.find(p => p.id == product.id);

      if (!state.previouslyViewed.includes(product) && !productFound) {
        state.previouslyViewed = [product, ...state.previouslyViewed];
      }
    },
    changeSearchMode(state, newState){
      state.searchMode = newState;
    },
    setCategoryAllowedAttributes(state, newState){
      state.allowedCategoryAttributes = newState;
    }
  },
  actions: {
    async toggleWishlist({ commit, dispatch }, info) {
      const params = new URLSearchParams();
      params.append('action', 'add_to_wishlist');
      params.append('product_id', info.product_id);
      params.append('quantity', info.quantity);
      params.append('package', info.package);

      const {data} = await axios.post(ws_vue_store.ajax_url, params)
      .catch(function (error) {
        console.log(error);
      });

      let isWishlistView = router.currentRoute.name === "Wishlist";
      if (data && data.success) {
        if (data.data.fragments) {
          FragmentsRenderer.renderFragments(data.data.fragments);
          feather.replace();
        }

        if (data.data.was_removed) {
          commit('removeFromActiveWishlist', info.product_id);
          dispatch("displayWoocommerceNotice", {
            message: ws_vue_store.translations.wishlist_removed
          });

          if (isWishlistView) {
            commit('updateViewWishlistTotal', info.price * info.quantity * -1);
            commit('updateViewWishlistCount', -1);
          }
        } else {
          commit('addToActiveWishlist', {'product_id': info.product_id, 'quantity': info.quantity});
          dispatch("displayWoocommerceNotice", {
            message: ws_vue_store.translations.wishlist_added
          });

          if (isWishlistView) {
            commit('updateViewWishlistTotal', info.price * info.quantity);
            commit('updateViewWishlistCount', 1);
          }
        }
      }
    },
    async updateWishlist({ commit, state }, info) {
      const params = new URLSearchParams();
      params.append('action', 'update_wishlist');
      params.append('product_id', info.product_id);
      params.append('quantity', info.quantity);
      params.append('package', info.package);

      const {data} = await axios.post(ws_vue_store.ajax_url, params)
      .catch(function (error) {
        console.log(error);
      });

      if (data && data.success) {
        let difference = (info.price * info.quantity - info.price * info.old_quantity).toFixed(2);
        commit('updateViewWishlistTotal', difference);
        commit('addToActiveWishlist', {'product_id': info.product_id, 'quantity': info.quantity});
      } else {
        console.log('Quantity update failed: ' + data ? data.data : '');
      }
    },
    async getProductsByIds({ commit, state }, ids) {
      axios.get(`${ws_vue_store.products_by_ids_endpoint}${ids}/${ws_vue_store.language_code}`)
        .then(result => {
          if (result && result.data && result.data.state == 'OK') {
            commit('setProductsCount', result.data.total);
            commit('setProducts', result.data.list);
            commit('changeLoadingState', false);
            commit('changeProductsLoadingState', false);
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    async searchProducts({ commit, state }, payload) {
      if(typeof payload.keyword == undefined) return;

      let postData = {
        'filters': {
          'keyword': payload.keyword,
          'languageCode': ws_vue_store.language_code,
          'keyword_extra_fields': ws_vue_store.search_additional_fields
        },
        'sort': 'search',
        'pageLimit': 5
      }

      if (ws_vue_store.discount_rules) {
        postData['filters']['discountRules'] = ws_vue_store.discount_rules
      }

      if (ws_vue_store.search_exclude_description) {
        postData['filters']['keyword_exclude_description'] = true;
      }

      if (ws_vue_store.attribute_custom_order == '1') {
        postData['attr_custom_order'] = true;
      }

      if (ws_vue_store.new_product_categories) {
        postData['new_cate'] = ws_vue_store.new_product_categories;
      }

      try {
        const result = await axios.post(ws_vue_store.products_endpoint, postData);

        if (result && result.data && result.data.state == 'OK') {
          commit('setSearchProducts', result.data.list);
        }
      } catch (error) {
        console.error("Request error:", error);
      }
    },
    async getProducts({ commit, dispatch, state, getters}) {
      var isHomePage = getters.isHomePage();

      let postData = {
        'filters': {
          ...state.filters.current,
          'keyword': getters.getSearchTerm(),
          'priceSlider': state.filters.priceSlider,
          'languageCode': ws_vue_store.language_code,
          'keyword_extra_fields': ws_vue_store.search_additional_fields
        },
        'custom_price': {},
        'product_custom_fields' : {},
        'sort': state.view.sort.code,
        'pageIndex': state.view.page - 1,
        'pageLimit': state.view.perPage
      }

      if (router.currentRoute.name === "Wishlist") {
        if (router.currentRoute.params.wishlist_uid) {
          postData['filters']['wishlist'] = router.currentRoute.params.wishlist_uid;
          postData['filters']['sort'] = 'wishlist';
        } else {
          // No wishlist selected
          commit('setProductsCount', 0);
          commit('setProducts', []);
          commit('changeLoadingState', false);
          commit('changeProductsLoadingState', false);
          return;
        }
      }

      if (state.filters.keyword) {
        postData['sort'] = 'search';
      }

      if (getters.getSKUSearchMode()) {
        postData['filters']['keyword_search_sku'] = true;
      }

      if (ws_vue_store.search_exclude_description) {
        postData['filters']['keyword_exclude_description'] = true;
      }

      if (ws_vue_store.new_product_categories) {
        postData['new_cate'] = ws_vue_store.new_product_categories;
      }

      if (ws_vue_store.attribute_custom_order == '1') {
        postData['attr_custom_order'] = true;
      }

      if (ws_vue_store.custom_order_for_variations == '1') {
        postData['vari_custom_order'] = true;
      }

      if(state.filters.onSaleProducts != undefined && state.filters.onSaleProducts){
        postData['filters']['on_sale_products'] = state.filters.onSaleProducts;
      }

      if(state.filters.newProducts != undefined && state.filters.newProducts){
        postData['filters']['is_new'] = state.filters.newProducts;
      }

      if(isHomePage){
        postData['filters']['is_featured'] = true;
        // Change default sort to featured sort
        if (ws_vue_store.catalog_orderby_options[0].code === postData['sort']) {
          postData['sort'] = 'featured';
        }
      }

      if (ws_vue_store.discount_rules) {
        postData['filters']['discountRules'] = ws_vue_store.discount_rules
      }

      if(ws_vue_store.config['product-grid'] == 'wells'){
        let allowedAttributes = ws_vue_store.config.allowed_attributes;
        if(state.allowedCategoryAttributes != undefined && state.allowedCategoryAttributes.length > 0){
          allowedAttributes = state.allowedCategoryAttributes;
        }
        postData['include_meta_fields'] = true;

        if(allowedAttributes.length > 0){
          let metaFields = allowedAttributes.map(function(attribute, index){
            return 'attribute_' + attribute;
          });
          postData['meta_fields'] = metaFields;
        }
      }

      if(ws_vue_store.company_id){
        postData['custom_price']['company_id'] = ws_vue_store.company_id;
      }
      if(ws_vue_store.project_searchcode){
        postData['custom_price']['project_searchcode'] = ws_vue_store.project_searchcode;
      }

      if(ws_vue_store.show_measurement_unit == '1'){
        postData['product_custom_fields'].measurement_unit = 'string';
      }

      if(ws_vue_store.enable_buying_step == '1'){
        postData['product_custom_fields'].buying_step = 'float';
      }

      postData['product_custom_fields'].custom_form = 'string';
      postData['product_custom_fields'].dangerous_goods = 'string';

      try {
        const result = await axios.post(ws_vue_store.products_endpoint, postData);

        if (result && result.data && result.data.state == 'OK') {
          commit('setProductsCount', result.data.total);
          commit('setProducts', result.data.list);
          commit('setViewWishlistTotal', result.data.wishlist_amount);
          commit('setViewWishlistCount', result.data.total);
          commit('changeLoadingState', false);
          commit('changeProductsLoadingState', false);
        }
      } catch (error) {
        console.error("Request error:", error);
      }
    },
    setFiltersFromUrl({ commit, state, getters }) {
      const queryParams = getters.getFiltersFromUrl();

      let search = queryParams.search_term || queryParams.search_sku;
      if(search || search != undefined){
        commit('changeSearchMode', true);

        commit("addFilter", {
          taxonomy: 'keyword',
          option: Array.isArray(search) ? search[0] : search
        });

        if (queryParams.search_sku) {
          commit('setSKUSearch', true);
          delete queryParams.search_sku;
        } else {
          delete queryParams.search_term;
        }
      }

      if (queryParams.ws_sort) {
        state.view.sort = ws_vue_store.catalog_orderby_options.find(sort => sort.code === queryParams.ws_sort);
        delete queryParams.ws_sort;
      }

      if (queryParams.ws_per_page) {
        state.view.perPage = parseInt(queryParams.ws_per_page, 10);
        delete queryParams.ws_per_page;
      }

      if (queryParams.ws_page && Number(queryParams.ws_page)) {
        state.view.page = parseInt(queryParams.ws_page, 10);
        delete queryParams.ws_page;
      }

      if (router.currentRoute.params && router.currentRoute.params.category_slug) {
        commit("setCategoryFromPath", router.currentRoute.params.category_slug);
      }
      commit("updateCategoryPath");
      commit("isCurrentCategoryRent");

      for (const key of Object.keys(queryParams)) {
        if (key.search('ws_') !== 0) continue; // Skip if not our filter

        if (Array.isArray(queryParams[key])) {
          for (const option of queryParams[key]) {
            commit("addFilter", {
              taxonomy: key.replace("ws_", ""),
              option: key === "ws_product_cat" ? parseInt(option, 10) : option
            });
          }
        } else {
          commit("addFilter", {
            taxonomy: key.replace("ws_", ""),
            option: key === "ws_product_cat" ? parseInt(queryParams[key], 10) : queryParams[key]
          });
        }
      }
    },
    async getAttributes({ commit, state }) {
      try {
        const url = ws_vue_store.attributes_endpoint + ws_vue_store.language_code;
        const result = await axios.get(url);

        if (result && result.data && result.data.state == 'OK') {
        }
      } catch (error) {
        console.error("Request error:", error);
      }
    },
    async getFilteredAttributes({ commit, state, getters }) {
      let postData = {
        'filters': {
          'priceSlider': state.filters.priceSlider,
          'languageCode': ws_vue_store.language_code,
        },
        'show_excluded': state.showExcludedAttributes
      }

      if (ws_vue_store.filter_attributes_by_category !== '1') {
        Object.assign(postData.filters, state.filters.current);
      } else if (state.filters.current.product_cat) {
        postData.filters['product_cat'] = state.filters.current.product_cat;
      }

      if (state.filters.keyword) {
        postData.filters.keyword = state.filters.keyword;
      }

      if (ws_vue_store.attribute_custom_order == '1' || ws_vue_store.filter_options_custom_order == '1') {
        postData['custom_order'] = true;
      }
      try {
        const result = await axios.post(ws_vue_store.filtered_attributes_endpoint, postData);

        if (result && result.data && result.data.state == 'OK') {
          if(state.showExcludedAttributes){
            commit('changeShowExcludedAttributes', false);
            commit('changeAttributesFirstLoadingState', true);
          }
          commit("setAttributeTaxonomies", result.data.data.attributes);
          commit('setProductsHighestPrice', result.data.data.max_price);
          commit('setFilteredAttributeTaxonomies', result.data.data.attributes);
        }
      } catch (error) {
        console.error("Request error:", error);
      }
    },
    async addFilter({ dispatch, commit, state }, payload) {
      commit('changeProductsLoadingState', true);

      state.view.page = 1;

      if (payload.taxonomy === "product_cat") {
        commit('changeShowExcludedAttributes', true);
        commit('updatePriceFilter', { 'value': null, 'type': 'min' } );
        commit('updatePriceFilter', { 'value': null, 'type': 'max' } );
        state.filters.current = { product_cat: [payload.option] };
        commit('updateCategoryPath');
        commit("isCurrentCategoryRent");
      } else {
        commit("addFilter", payload);
      }

      commit("updateUrlQuery");

      dispatch("getFilteredAttributes", [])
      .then(() => dispatch("getProducts", []));
    },
    displayWoocommerceNotice({}, payload) {
      const existingWrapper = document.querySelector('.woocommerce-notices-wrapper');
      if (existingWrapper) {
        existingWrapper.remove();
      }
    
      let wrapper = document.createElement('div');
      let notice = document.createElement('div');
    
      wrapper.classList.add('woocommerce-notices-wrapper');
      notice.classList.add('woocommerce-message');
      if (payload.extraClass) notice.classList.add(payload.extraClass);
      notice.role = 'alert';
      notice.tabIndex = -1;
      notice.innerHTML = payload.message;
    
      wrapper.append(notice);
      document.querySelector('#content').append(wrapper);
    },    
    removeFilter({ dispatch, commit, state }, payload) {
      commit('changeProductsLoadingState', true);
      commit("removeFilter", payload);

      commit("updateUrlQuery");

      dispatch("getFilteredAttributes", [])
      .then(() => dispatch("getProducts", []));
    }
  },
  mounted() {},
  modules: {}
});